import styles from './index.module.scss';
import SectionPro from '../components/SectionPro';
import EFPicture from '@elem/compCommon/EFPicture';

const BundleBox: React.FC = () => {
    return (
        <div className={`${styles.BundleBox} GtmModuleData-section`} data-section-id={styles.BundleBox} data-section-title="同梱物">
            <SectionPro title="同梱物">
                <div className="card-list">
                    <div className="card card-1">
                        <div className="title">DELTA 2 Max本体</div>
                        <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1744982162006/image%201033%20(1).png" />
                    </div>
                    <div className="card card-2">
                        <div className="title">
                            専用AC充電
                            <br />
                            ケーブル
                        </div>
                        <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1744982819234/Frame%201612707432.png" />
                    </div>
                    <div className="card card-3">
                        <div className="title">
                            シガーソケット
                            <br />
                            充電ケーブル
                        </div>
                        <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1744982819403/Frame%201612707433.png" />
                    </div>
                    <div className="card card-4">
                        <div className="title">DC5521 -DC5525ケーブル</div>
                        <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1744982819598/Frame%201612707434.png" />
                    </div>
                    <div className="card card-5">
                        <div className="title nowrap">
                            ユーザーマニュアル
                            <br />
                            保証書
                        </div>
                        <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1744982819046/Frame%201612707435.png" />
                    </div>
                </div>
            </SectionPro>
        </div>
    );
};

export default BundleBox;
